import { webApiWithResponse } from "../../../../../core/http/httpThunks";
import { ClientAccount } from "../../types";

export const updateClientAccountApi = (userId: string, account: ClientAccount) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/updclimonacc",
		params: {
			userId
		},
		data: account
	});

export default updateClientAccountApi;
